import { View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { ContactsSelect, Text } from '@pletly/ui';
import { OrganisationRole, useOrganisationInfo } from '@pletly/feature-organisation';

interface Props {
	selected: boolean;
	onPress: () => void;
}

const ITEM_ID = 'all-employees';

export const AllStaffSelect = ({ onPress, selected }: Props) => {
	const { t } = useTranslation();
	const { organisationInfo } = useOrganisationInfo();

	if (
		!organisationInfo ||
		![OrganisationRole.Admin, OrganisationRole.Manager].includes(organisationInfo.role)
	) {
		return null;
	}

	return (
		<View>
			<Text category="h5">{t('post.new.organisation')}</Text>

			<ContactsSelect
				mode="single"
				contacts={[{ id: ITEM_ID, name: t('post.new.all-employees') }]}
				selectedIds={selected ? [ITEM_ID] : []}
				setSelectedIds={onPress}
			/>
		</View>
	);
};
